import React, { useState } from 'react';

/**
 * ColumnVisibilityMenu - Dropdown to show/hide table columns
 * 
 * Features:
 * - Toggle individual columns
 * - Show/hide all
 * - Reset to defaults
 */

export default function ColumnVisibilityMenu({ table, onReset }) {
  const [isOpen, setIsOpen] = useState(false);

  const allColumns = table.getAllLeafColumns().filter(column => column.getCanHide());
  const visibleCount = allColumns.filter(col => col.getIsVisible()).length;

  return (
    <div className="dropdown">
      <button
        className="btn btn-outline-secondary btn-sm dropdown-toggle"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        Columns ({visibleCount}/{allColumns.length})
      </button>
      
      {isOpen && (
        <div className="dropdown-menu show" style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <div className="px-3 py-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <strong>Show/Hide Columns</strong>
              <button
                className="btn btn-sm btn-link text-decoration-none"
                onClick={onReset}
              >
                Reset
              </button>
            </div>
            
            <div className="form-check mb-2">
              <input
                type="checkbox"
                className="form-check-input"
                checked={table.getIsAllColumnsVisible()}
                onChange={table.getToggleAllColumnsVisibilityHandler()}
                id="toggle-all"
              />
              <label className="form-check-label fw-bold" htmlFor="toggle-all">
                Toggle All
              </label>
            </div>
            
            <hr className="my-2" />
            
            {allColumns.map(column => (
              <div key={column.id} className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={column.getIsVisible()}
                  onChange={column.getToggleVisibilityHandler()}
                  id={`column-${column.id}`}
                />
                <label className="form-check-label" htmlFor={`column-${column.id}`}>
                  {column.columnDef.header}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Backdrop to close dropdown when clicking outside */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

